import * as React from 'react';
import { useContext } from 'react';
import { BottomNavigation } from 'react-native-paper';
import { useRoute } from '@react-navigation/native';
import { useQuery } from '@apollo/client';
import InfoTab from './InfoTab';
import DocumentTab from './DocumentTab';
import PalmaresTab from './PalmaresTab';
import RentalsTab from './RentalsTab';
import NasMediaTab from './NasMediaTab';
import { AuthContext } from '../../../context/AuthContext';
import { ROLE_NAMES } from '../../../utils/constant';
import { MY_NAS_MEDIA } from '../../../gql/nas/query';

function ProfileTabs({ user, disabled = false }) {
  const route = useRoute();
  const { authState } = useContext(AuthContext);
  const isAdmin = authState.role === ROLE_NAMES.SUPERADMIN;
  const isOwnProfile = authState.email === user.email;

  // For users viewing their own profile: only show the tab if they have media
  const { data: nasData } = useQuery(MY_NAS_MEDIA, { skip: !isOwnProfile || isAdmin });
  const hasNasMedia = isAdmin || (nasData?.myNasMedia?.length ?? 0) > 0 || (isOwnProfile && user.canBrowseNas);

  const [index, setIndex] = React.useState(Number(route.params?.tabIndex ?? 0));
  const baseRoutes = [
    {
      key: 'info',
      title: 'Infos',
      focusedIcon: 'account-details',
      unfocusedIcon: 'account-details-outline',
    },
    {
      key: 'documents',
      title: 'Documents',
      focusedIcon: 'file-multiple',
      unfocusedIcon: 'file-multiple-outline',
    },
    {
      key: 'palmares',
      title: 'Palmarès',
      focusedIcon: 'trophy',
      unfocusedIcon: 'trophy-outline',
    },
  ];

  if (user.rentals && user.rentals.length > 0) {
    baseRoutes.push({
      key: 'rentals',
      title: 'Locations',
      focusedIcon: 'shopping',
      unfocusedIcon: 'shopping-outline',
    });
  }

  if (hasNasMedia) {
    baseRoutes.push({
      key: 'nas',
      title: 'Médias',
      focusedIcon: 'nas',
      unfocusedIcon: 'nas',
    });
  }

  const [routes] = React.useState(baseRoutes);

  const renderScene = BottomNavigation.SceneMap({
    info: () => <InfoTab user={user} disabled={disabled} />,
    documents: () => <DocumentTab user={user} disabled={disabled} />,
    palmares: () => <PalmaresTab user={user} />,
    rentals: () => <RentalsTab user={user} />,
    nas: () => <NasMediaTab user={user} />,
  });

  return (
    <BottomNavigation
      navigationState={{ index, routes }}
      onIndexChange={setIndex}
      renderScene={renderScene}
    />
  );
}

export default ProfileTabs;
